export const sendPDFToEmail = (nameFile, file, affairEmail, emailsDestiny) => {
    return new Promise((resolve, reject) => {
        var fd = new FormData();
        fd.append('asunto', affairEmail);
        fd.append('destinos', JSON.stringify(emailsDestiny));
        fd.append('nombre_archivo', nameFile);
        fd.append('archivo', file);

        fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/enviar-archivo-renderizado-correo', {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: fd
        }).then((response) => {
            if(response.status != 500 && response.status != 403 && response.status != 404)
            {
                resolve(true);
            }
            else
            {
                throw new Error("Data");
            }
        }).catch((err) => {
            reject(false);
        });
    });
}